
/* Fields */
const BANKER_STANDS = [
    { banker: 0, noThird: "D", values: ["D", "D", "D", "D", "D", "D", "D", "D", "D", "D"] },
    { banker: 1, noThird: "D", values: ["D", "D", "D", "D", "D", "D", "D", "D", "D", "D"] },
    { banker: 2, noThird: "D", values: ["D", "D", "D", "D", "D", "D", "D", "D", "D", "D"] },
    { banker: 3, noThird: "D", values: ["D", "D", "D", "D", "D", "D", "D", "D", "S", "D"] },
    { banker: 4, noThird: "D", values: ["S", "S", "D", "D", "D", "D", "D", "D", "S", "S"] },
    { banker: 5, noThird: "D", values: ["S", "S", "S", "S", "D", "D", "D", "D", "S", "S"] },
    { banker: 6, noThird: "S", values: ["S", "S", "S", "S", "S", "S", "D", "D", "S", "S"] },
    { banker: 7, noThird: "S", values: ["S", "S", "S", "S", "S", "S", "S", "S", "S", "S"] },
    { banker: 8, noThird: "S", values: ["S", "S", "S", "S", "S", "S", "S", "S", "S", "S"] },
    { banker: 9, noThird: "S", values: ["S", "S", "S", "S", "S", "S", "S", "S", "S", "S"] }
]


export const list = [
    {
        id: "game-objective",
        title: "Цель игры",
        content:
            <div className="content">
                <p>
                    <b>Punto Banco</b>
                    <br /><br />
                    Цель игры — предсказать, чья рука выиграет, имея значение, ближайшее к 9.
                </p>
            </div>
    },
    {
        id: "game-rules",
        title: "Правила игры",
        content:
            <div className="content">
                <p>Игра ведётся дилером и играется восемью стандартными колодами по 52 карты. Значения карт следующие:</p>
                <p>Тузы — самые младшие карты и стоят по 1 очку каждая.</p>
                <p>Карты от 2 до 9 стоят своих числовых значений.</p>
                <p>10 и картинки (валеты, дамы и короли) стоят 0 каждая.</p>
                <p>Только числовое значение каждой карты имеет значение в основной игре Punto Banco; масть каждой карты (черви, пики, трефы или бубны) не имеет значения.</p>
                <p><b>Сжигание карты.</b> Перед первой раздачей нового башмака дилер вынимает самую первую карту и откладывает её в уголок стола. Эта карта «сжигается»: она не участвует в раунде, не сдаётся ни Player, ни Banker и не влияет на результат игры.</p>
                <p>Перед каждой раздачей вы должны сделать ставку на то, выиграет ли Player или Banker раунд, имея руку со значением, ближайшим к 9.</p>
                <p>Если вы считаете, что и Player, и Banker будут иметь руки равного значения, у вас также есть возможность поставить на Tie.</p>
                <p>Кроме того, вы также можете поставить на Player/Banker Pair, которая выплачивается, если первые две карты, сданные Player/Banker, составляют пару.</p>
                <p>Дилер начинает с раздачи двух карт каждому — Player и Banker.</p>
                <p>В Punto Banco раздаются две руки: одна рука Player и одна рука Banker.</p>
                <p>Если Player и Banker имеют руки равного значения, раунд заканчивается ничьей. Ставка Tie выигрывает, а ставки на Player и Banker возвращаются.</p>
                <p>Значение каждой руки рассчитывается путём отбрасывания десятка в руке, которая в противном случае стоила бы 10 или больше. Например, рука, состоящая из 7 и 9, в Punto Banco стоит только 6 (потому что 16-10=6). Аналогично, картинка плюс 9 будет стоить 9.</p>
                <p>Если Player или Banker получает начальную руку из двух карт стоимостью 8 или 9 («натуральные» 8 или 9), дополнительные карты не будут сданы ни одной руке.</p>
                <p>Если Player и Banker получают начальные руки из двух карт стоимостью от 0 до 7, обращаются к «Правилу третьей карты», чтобы определить, будет ли третья карта сдана одной из рук или обеим рукам. Player всегда ходит первым.</p>
                <br />
                <p><b>Рука Player</b></p>
                <p>Начальная комбинация из двух карт Player</p>

                <table className="rules-table">
                    <tbody>
                        <tr>
                            <td>0-1-2-3-4-5</td>
                            <td>Player берёт третью карту, если только у Banker нет натуральных 8 или 9.</td>
                        </tr>
                        <tr>
                            <td>6-7</td>
                            <td>Player остаётся.</td>
                        </tr>
                        <tr>
                            <td>8–9 («натуральные»)</td>
                            <td>Нет третьей карты ни одной руке.</td>
                        </tr>
                    </tbody>
                </table>

                <p><b>Рука Banker</b></p>

                <table className="banker-table">
                    <thead>
                        <tr>
                            <th rowSpan="2" style={{ fontSize: 10 }}>Значение из двух карт Banker</th>
                            <th rowSpan="2">Без третьей карты</th>
                            <th colSpan="10">Значение третьей карты Player</th>
                        </tr>
                        <tr>
                            {Array.from(9).map(v => <td>{v}</td>)}
                        </tr>
                    </thead>

                    <tbody>
                        {BANKER_STANDS.map(row =>
                            <tr key={`${row.banker}`}>
                                <td>{row.banker}</td>
                                <td>{row.noThird}</td>
                                {row.values.map((v, i) => <td key={`${row.banker}:${i}`} className={`${v === "D" ? "active" : "default"}`}>{v}</td>)}
                            </tr>
                        )}
                    </tbody>

                </table>

                <p>D — Draw (взять карту); S — Stand (остаться).</p>

                <p>
                    Если рука Player остаётся на 6 или 7, тогда рука Banker со значением 3, 4 или 5 должна взять карту,
                    а рука Banker со значением 6 должна остаться.
                </p>

                <p>Кто получает руку, ближайшую к общему значению 9, тот выигрывает.</p>

            </div>
    },
    {
        id: "side-bets",
        title: "Дополнительные ставки",
        content:
            <div className="content">
                <p><b>Player Pair</b></p>
                <p>Выплачивается 11:1, если первые две карты, сданные Player, составляют пару.</p>
                <p>Максимальная ставка на Player Pair не может превышать 10% от общей суммы основной максимальной ставки.</p>

                <p><b>Banker Pair</b></p>
                <p>Выплачивается 11:1, если первые две карты, сданные Banker, составляют пару.</p>
                <p>Максимальная ставка на Banker Pair не может превышать 10% от максимальной ставки.</p>

                <p><b>Perfect Pair</b></p>
                <p>Выплачивается 25:1, если две одинаковые карты (по значению и масти) сданы как первые две карты либо Banker, либо Player.</p>
                <p>Максимальная ставка на Perfect Pair не может превышать 3% от максимальной ставки.</p>

                <p><b>Either Pair</b></p>
                <p>Выплачивается 5:1, если либо рука Banker, либо рука Player является парой.</p>
                <p>Максимальная ставка на Either Pair не может превышать 10% от максимальной ставки.</p>

            </div>
    },
    {
        id: "payouts",
        title: "Выплаты",
        content:
            <div className="content">
                <p>Ваша выплата зависит от типа сделанной ставки.</p>

                <p><b>Bet</b></p>
                <p><b>Payout</b></p>

                <p>Player — 1:1</p>
                <p>Banker* — 0.95:1</p>

                <p>Tie — 8:1</p>
                <p>11:1</p>
                <p>One hand: 25:1</p>
                <p>Both hands: 200:1</p>
                <p>5:1</p>

                <p>*95% вашей ставки Banker возвращается, если Banker выигрывает</p>
                <p>Пожалуйста, обратите внимание, что любая неисправность аннулирует игровой раунд и все возможные выплаты за раунд. Ставки будут возвращены.</p>
            </div>
    },
    {
        id: "place-bets",
        title: "Размещение ставок",
        content:
            <div className="content">
                <p>Панель BET LIMITS показывает минимальные и максимальные допустимые лимиты ставок за столом, которые могут время от времени меняться. Откройте Bet Limits, чтобы проверить ваши текущие лимиты.</p>
                <p><b>Punto Banco</b></p>
                <p>Чтобы участвовать в игре, у вас должно быть достаточно средств, чтобы покрыть ваши ставки. Вы можете видеть ваш текущий BALANCE на экране.</p>
                <p>BALANCE</p>
                <p>USD 10,000</p>

                <p>В Immersive view TIMER информирует вас о длительности времени ставок. После его истечения ставки закрываются, и больше никакие ставки не принимаются.</p>

                <p>В Classic view TRAFFIC LIGHTS сообщают вам текущий статус игрового раунда, информируя вас, когда вы можете ставить (GREEN light), когда время ставок почти истекло (YELLOW light), и когда время ставок истекло (RED light).</p>

                <p>PLACE YOUR BETS</p>
                <p>CHIP DISPLAY позволяет вам выбрать значение каждой фишки, на которое вы хотите поставить. Только фишки тех номиналов, которые могут быть покрыты вашим текущим балансом, будут доступны.</p>
                <p>500 / 1000 / 2500 / 12k+ / 50k / 250k</p>

                <p>После того как вы выбрали фишку, сделайте ставку, просто нажав/коснувшись соответствующей области ставки на игровом столе. Каждый раз, когда вы нажимаете/касаетесь области ставки, сумма вашей ставки увеличивается на значение выбранной фишки или до максимального лимита для типа ставки, который вы выбрали. Как только вы поставили максимальный лимит, дополнительные средства для этой ставки больше не будут приниматься, и над вашей ставкой появится сообщение, уведомляющее вас, что вы поставили максимум.</p>

                <p>ПРИМЕЧАНИЕ: Пожалуйста, не сворачивайте браузер и не открывайте никакую другую вкладку в вашем браузере, пока время ставок ещё остаётся и вы сделали ставки на столе. Такие действия могут быть истолкованы как выход из игры, и поэтому ваши ставки будут отклонены для этого конкретного игрового раунда.</p>

                <p>Кнопка REPEAT позволяет вам повторить все ставки из предыдущего игрового раунда. Эта кнопка доступна только до того, как размещена первая фишка.</p>
                <p>REPEAT</p>

                <p>Кнопка DOUBLE (x2) становится доступной после того, как вы сделали любую ставку. Каждое нажатие/касание удваивает все ваши ставки до максимального лимита. Обратите внимание, что у вас должен быть достаточный баланс счёта, чтобы удвоить ВСЕ ваши размещённые ставки.</p>
                <p>DOUBLE</p>

                <p>Кнопка UNDO убирает последнюю ставку, которую вы сделали.</p>
                <p>UNDO</p>

                <p>Вы можете нажимать/касаться кнопку UNDO многократно, чтобы убирать ставки, одну за другой, в обратном порядке, в котором они были размещены. Вы можете очистить все ваши ставки, удерживая кнопку UNDO.</p>
                <p>Индикатор TOTAL BET показывает общую сумму всех ставок, размещённых в текущем раунде.</p>

                <p>TOTAL BET</p>
                <p>KZT 500</p>

            </div>
    },
    {
        id: "live-support",
        title: "Live Support",
        content:
            <div className="content">
                <p>Свяжитесь с Live Support по вопросам, связанным с игрой.</p>
            </div>
    },
    {
        id: "chat",
        title: "Чат",
        content:
            <div className="content">
                <p>Общайтесь с другими игроками и/или с ведущим игры.</p>
            </div>
    },
    {
        id: "scorecards",
        title: "Scorecards",
        content:
            <div className="content">
                <p>Серии и тенденции Baccarat для Player или Banker с использованием конкретного shoe записываются в различных табло. Эти наглядные представления результатов прошлых раундов и другая статистика относительно текущего shoe могут быть полезны вам в предсказании результатов будущих раундов.</p>
                <p>BEAD ROAD и BIG ROAD показывают результаты каждого прошлого раунда, тогда как Big Eye Road, Small Road и Cockroach Road показывают шаблоны, полученные из BIG ROAD.</p>
                <p>Roads и статистика shoe всегда очищаются, когда вводится новый shoe.</p>

                <p><b>BEAD ROAD</b></p>
                <p>Каждая ячейка в BEAD ROAD представляет результат прошлого раунда. Результат самого раннего раунда записывается в верхнем левом углу. Читайте колонку вниз до самого низа; затем начинайте сверху соседней колонки справа и так далее. Сплошная красная ячейка указывает на победу Banker. Сплошная синяя ячейка представляет победу Player. Сплошная зелёная ячейка представляет Tie. Красная точка в правом нижнем углу ячейки означает, что у Banker была пара. Синяя точка в верхнем левом углу ячейки означает, что у Player была пара.</p>
                <p>Вы можете изменить отображение Bead Road с английского на упрощённый китайский или Score Mode, нажав/коснувшись его в любом месте.</p>

                <p><b>BIG ROAD</b></p>
                <p>В BIG ROAD результат самого раннего раунда записывается в верхнем левом углу.</p>
                <p>Новая колонка создаётся каждый раз, когда выигрышная серия Banker меняется в пользу Player, или наоборот.</p>
                <p>Ячейка, обведённая красным, указывает на победу Banker. Ячейка, обведённая синим, указывает на победу Player.</p>
                <p>Tie записывается как зелёная линия через ячейку предыдущего раунда. Если первый раунд — Tie, зелёная линия появится первой, а красная или синяя обводка появится вокруг линии, как только Player или Banker выиграет раунд.</p>
                <p>Если есть две или более последовательные ничьи, число на линии покажет количество ничьих.</p>

                <p><b>DERIVED ROADS</b></p>
                <p>Для истинного энтузиаста Baccarat Big Eye Road, Small Road и Cockroach Road включены, чтобы показывать шаблоны, полученные из прошлых результатов, записанных в BIG ROAD. Big Eye Road использует обведённые круги, Small Road использует сплошные круги, а Cockroach Road использует косые линии. Однако в этих производных roads красный и синий цвета не соответствуют победам Banker и Player, и нет способа различить ничьи или пары. В производных roads красные записи являются признаком повторения, тогда как синие записи сигнализируют о более хаотичном, «рваном» shoe.</p>
                <p>Производные roads не начинаются с самого начала shoe. Они начинаются с руки, следующей за первой рукой во второй, третьей и четвёртой колонках BIG ROAD. Как только производная road начинается, дополнительный красный или синий символ добавляется после каждого раунда.</p>

                <p><b>SHOE STATISTICS</b></p>
                <p>Следующая статистика, основанная на текущем shoe, показывается для вас:</p>
                <p>Total — количество завершённых раундов на данный момент. Player — количество побед Player на данный момент. Banker — количество побед Banker на данный момент. Tie — количество ничейных раундов на данный момент. Banker (Pair) — количество пар Banker на данный момент. Player (Pair) — количество пар Player на данный момент.</p>

                <p><b>ROAD PROBING TABLE</b></p>
                <p>Road PROBING Table показывает значок, который будет добавлен в три производные roads, если следующий раунд будет выигран Banker или Player. Нажмите кнопку Banker (B) или Player (P), чтобы увидеть значок, который будет добавлен в roads, если следующий раунд будет выигран Banker или Player.</p>
            </div>
    },
    {
        id: "game-number",
        title: "Номер игры",
        content:
            <div className="content">
                <p>Каждый игровой раунд определяется уникальным GAME NUMBER.</p>
                <p>Это число отражает, когда игровой раунд начался в терминах GMT по часам: минутам: секундам. Пожалуйста, используйте этот номер игры для ссылки (или сделайте снимок экрана номера игры), если вы хотите связаться с Customer Service относительно конкретного раунда.</p>
            </div>
    },
    {
        id: "game-history",
        title: "История игры",
        content:
            <div className="content">
                <p>Game History показывает ваши игровые раунды Evolution и результаты.</p>
            </div>
    },
    {
        id: "error-handling",
        title: "Обработка ошибок",
        content:
            <div className="content">
                <p>Если есть ошибка в игре, системе или игровой процедуре, игровой раунд будет временно приостановлен, пока ведущий игры уведомляет менеджера сервиса. Вы и другие игроки будете уведомлены через Chat или всплывающим сообщением на экране, что проблема расследуется. Если менеджер может немедленно устранить ошибку, игровой раунд продолжится как обычно. Если немедленное устранение невозможно, игровой раунд будет отменён, а начальные ставки будут возвращены всем игрокам, которые участвовали в игровом раунде.</p>
            </div>
    },
    {
        id: "shuffling",
        title: "Тасование",
        content:
            <div className="content">
                <p>Игровой процесс продолжается, пока не будет сдана cut card. Впоследствии карты тасуются дилером или шафлером.</p>
                <p>После смены башмака дилер сжигает первую карту — вынимает её из башмака и откладывает в уголок стола. Сожжённая карта не участвует в игре.</p>
                <p>Если доступен shuffle table, тогда за столом используются два shoe с двумя наборами игральных карт. В этом случае дилер меняет shoe, а тасование выполняется шафлером за столом тасования, пока дилер продолжает вести игровой раунд.</p>
            </div>
    },
    {
        id: "disconnection-policy",
        title: "Политика отключения",
        content:
            <div className="content">
                <p>Если вы отключены от игрового раунда, любые размещённые ставки остаются действительными и рассчитываются в ваше отсутствие. После повторного подключения вы можете посмотреть результаты ставок в окне History.</p>
            </div>
    }
]